/**
 * In this file we handel to show the OTP popup screen and OTP Verify logic
 **/
import { useState } from 'react';
import Modal from "react-bootstrap/Modal";
import { convertS3privateToPublic } from '../../services/UtilsService';

function ViewDevelopmentImage(props) {
	//Intial state declaraction
  // eslint-disable-next-line
	const [modal,setModal]=useState({});
  const role = Number(localStorage.getItem('role'));
	//To close modal
  // eslint-disable-next-line
	const handleClose=()=>setModal({});

  return (
    <Modal
      show={props?.data?.status}
      onHide={props.handleClose}
      backdrop="static"
      keyboard={false}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
        <Modal.Title><h5 className="modal-title" id="ViewDevelopmentImageLabel">{props.data.title}</h5>
		</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <p>{props.data.question}</p>
      <hr/>
      <img src={convertS3privateToPublic(props.data.image)} alt="Development Question" style={{ display: 'block', margin: '0 auto' }} />
      </Modal.Body>
    </Modal>
  );
}

export default ViewDevelopmentImage;
